export default "__VITE_ASSET__bakW6hpv__"